export const COOKIE_NAME = "eceosCookieName"
